import { lerp } from './math';
import { vec2_length, vec2_angle, vec2_distance } from './vec2';

;(function() {
    var element = document.getElementById('js-AnimArchitecture');

    if (element === null) {
        return;
    }

    function init(assets) {

        var images = assets;

        function Particle_make(system, obj) {
            var result = obj || {};

            var imagePickList = images;
            var image = imagePickList[Math.floor(Math.random() * imagePickList.length)];
            var maxLife = system.maxParticleLife - system.minParticleLife;

            result.x = width * 0.30 + (Math.random() * (width - (width * 0.60)));
            result.y = height + Math.random() * height;
            result.rotation = Math.random() * Math.PI * 2.0
            result.vx = 0.0;
            result.vy = -0.25 + Math.random() * -0.75;
            result.image = image;
            result.halfWidth = image.width / 2.0;
            result.halfHeight = image.height / 2.0;
            result.drawScale = 0.5;
            result.lifeMax = system.minParticleLife + Math.floor(maxLife);
            result.life = result.lifeMax;

            return result;
        }

        function Attractor_and_Particle(a, p, dt) {
            var dist = vec2_distance([a.x, a.y], [p.x, p.y]);
            var angle = vec2_angle([a.x - p.x, a.y - p.y]);

            var force = Math.pow(Math.max(1.0 - (dist / a.radius), 0.0), 1.5);

            p.vx += Math.cos(angle) * force * dt;
            p.vy += Math.sin(angle) * force * dt;
        }

        function Death_and_Particle(s, d, p) {
            var dist = vec2_distance([d.x, d.y], [p.x, p.y]);

            if (dist < d.radius + p.halfWidth) {
                p.life -= 1;
                if (p.life <= 0) {
                    Particle_make(s, p);
                }
            }
        }

        function Trap_and_Particle(t, p) {
            var dist = vec2_distance([t.x, t.y], [p.x, p.y]);

            var force = Math.pow(Math.min(dist / t.radius, 1.0), 0.85);

            p.vx *= force;
            p.vy *= force;
        }

        var wrapper = document.createElement('div');
        var target = element.parentElement;

        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');

        canvas.style.width = '100%';
        canvas.style.height = '100%';
        canvas.style.left = '0';
        canvas.style.top = '0';
        canvas.style.position = 'absolute';
        canvas.style.opacity = '0';
        canvas.style.transition = 'opacity 550ms ease-in';
        element.style.transition = 'opacity 550ms ease-out';
        wrapper.style.position = 'relative';

        wrapper.appendChild(element);
        wrapper.appendChild(canvas);
        target.appendChild(wrapper);

        var width = target.clientWidth;
        var height = target.clientHeight;

        canvas.width = width * 1.5;
        canvas.height = height * 1.5;

        var frame = {
            start: 0,
            ended: 0,
            delta: 0
        };

        ctx.scale(1.5, 1.5);

        var lightGradient = ctx.createRadialGradient(0, 0, 16, 0, 0, 32);

        lightGradient.addColorStop(0, '#ffd417');
        lightGradient.addColorStop(0.9, 'rgba(255, 212, 23, 0)');

        var systems = [
            {
                rotation       : Math.PI * 0.25,
                offset         : [-width * 0.225, -height * 0.32],
                numParticles   : 30,
                minParticleLife: 150,
                maxParticleLife: 300,
                target         : [width / 2.0, height / 2.0],
                particles      : [],
                attractors     : [{ x: width / 2.0, y: height / 2.0, radius: width * 0.35 }],
                deaths         : [{ x: width / 2.0, y: height / 2.0, radius: width * 0.15 }],
                traps          : [{ x: width / 2.0, y: height / 2.0, radius: width * 0.15 }]
            },{
                rotation       : Math.PI * 1.25,
                offset         : [-width * 0.225, -height * 0.20],
                numParticles   : 30,
                minParticleLife: 4,
                maxParticleLife: 16,
                target         : [width / 2.0, height / 2.0],
                particles      : [],
                attractors     : [{ x: width / 2.0, y: height / 2.0, radius: width * 0.35 }],
                deaths         : [{ x: width / 2.0, y: height / 2.0, radius: width * 0.15 }],
                traps          : []
            }
        ];
        var beams = [];
        var pile = [];

        var NUM_BEAMS = 5;
        for (var i = 0; i < NUM_BEAMS; ++i) {
            var w = lerp(80, 140, Math.random());
            var h = 16;
            var pos = [
                width/2,
                (height/2)+((1.0-(i/(NUM_BEAMS-1))*2.0)*(NUM_BEAMS-1)*((h/2)+2))-(h/2)
            ];
            var wTarget = w+lerp(80, 140, Math.random());

            var colorPickList = [
                '#4ba8dc', // blue,
                '#82c678', // green,
                '#e25d5d', // red,
                '#f79b28', // orange,
                '#ffd417', // yellow
            ];

            beams.push({
                position: { x: pos[0], y: pos[1] },
                size: { width: w, height: h },
                widthTarget: wTarget,
                color: colorPickList[i % NUM_BEAMS]
            });
        }

        for (var i = 0; i < 32; ++i) {
            var p = Particle_make(systems[0], {});
            var a = Math.random() * Math.PI * 2.0;
            var l = 4.0 + (Math.random() * 80.0);
            p.x = (width / 2.0) + Math.cos(a) * l
            p.y = ((height / 2.0) + (height * 0.125)) + Math.sin(a) * l
            pile.push(p)
        }


        for (var i = 0; i < systems.length; ++i) {
            for (var c = 0; c < systems[i].numParticles; ++c) {
                systems[i].particles[c] = Particle_make(systems[i], {});
            }
        }

        canvas.style.opacity = 1;
        element.style.opacity = 0;

        function update() {
            frame.start = performance.now();
            frame.delta = (frame.start - frame.ended) / 1000;
            frame.ended = frame.start;

            ctx.clearRect(0, 0, width, height);

            // @NOTE(Grey): Draw pile of stale particles
            ctx.save();
            ctx.translate(width / 2.0, height / 2.0);
            ctx.rotate(systems[0].rotation);
            ctx.translate(-width / 2.0, -height / 2.0);
            ctx.translate(systems[0].offset[0], systems[0].offset[1]);
            for (var i = 0; i < pile.length; ++i) {
                var p = pile[i]
                ctx.save();
                ctx.translate(p.x, p.y);
                ctx.rotate(p.rotation);
                ctx.scale(p.drawScale, p.drawScale);
                ctx.drawImage(p.image, -p.halfWidth, -p.halfHeight);
                ctx.restore();
            }
            ctx.restore();

            for (var j = 0; j < systems.length; ++j) {
                var system = systems[j];
                var particles = system.particles;
                var attractors = system.attractors;
                var deaths = system.deaths;
                var traps = system.traps;

                ctx.save();
                ctx.translate(width / 2.0, height / 2.0);
                ctx.rotate(system.rotation);
                ctx.translate(-width / 2.0, -height / 2.0);
                ctx.translate(system.offset[0], system.offset[1]);

                for (var i = 0; i < system.numParticles; ++i) {
                    var p = particles[i];

                    particles[i].x += (p.vx * 100) * frame.delta;
                    particles[i].y += (p.vy * 100) * frame.delta;

                    for (var c = 0; c < attractors.length; ++c) {
                        Attractor_and_Particle(attractors[c], particles[i], 0.16);
                    }

                    for (var c = 0; c < deaths.length; ++c) {
                        Death_and_Particle(system, deaths[c], particles[i]);
                    }

                    for (var c = 0; c < traps.length; ++c) {
                        Trap_and_Particle(traps[c], particles[i]);
                    }

                    var angle = vec2_angle([system.target[0] - p.x, system.target[0] - p.y]);
                    var x = system.target[0] + Math.cos(angle) * (width / 2.15);
                    var y = system.target[1] + Math.sin(angle) * (height / 2.15);

                    var dist = vec2_distance(system.target, [p.x, p.y]);
                    var limit = vec2_distance(system.target, [x, y]);

                    var distT = Math.max(1.0 - (dist / limit), 0.0);
                    var lifeT = 1.0 - (p.life / p.lifeMax);
                    var opacity = Math.min(Math.pow(distT, 0.65) * 2.0, 1.0) - lifeT;

                    ctx.save();

                    ctx.translate(p.x, p.y);
                    ctx.rotate(p.rotation);

                    ctx.globalAlpha = opacity;

                    ctx.scale(p.drawScale, p.drawScale);
                    ctx.drawImage(p.image, -p.halfWidth, -p.halfHeight);

                    ctx.globalAlpha = 1.0;

                    ctx.restore();

                    if (p.x > width || p.y > (height + height) || p.x < 0 || p.y < 0) {
                        Particle_make(system, particles[i]);
                    }
                }

                ctx.restore();
            }

            // @NOTE(Grey): Draw the two middle orange divider lines
            ctx.save();
            ctx.translate(width / 2.0, height / 2.0);
            ctx.rotate(systems[0].rotation);
            ctx.fillStyle = '#f79b28';
            ctx.fillRect(-2.0, (-height / 2.0) + 4.0, 1, height);
            ctx.fillRect(+2.0, (-height / 2.0) - 4.0, 1, height);
            ctx.restore();

            // @NOTE(Grey): Draw the big red x
            ctx.save();
            ctx.translate(width / 2.0, height / 2.0);
            ctx.rotate(Math.PI * 0.1123);
            ctx.translate(-width * 0.10, -height * 0.30);
            ctx.beginPath();

            var hw = (width * 0.25) / 2.0;
            var hh = hw;
            var sw = hw / 2.0;
            var hsw = sw / 2.0;

            ctx.moveTo(-hw , -hsw);
            ctx.lineTo(-hsw, -hsw);
            ctx.lineTo(-hsw, -hw);
            ctx.lineTo( hsw, -hw);
            ctx.lineTo( hsw, -hsw);
            ctx.lineTo( hw , -hsw);
            ctx.lineTo( hw ,  hsw);
            ctx.lineTo( hsw,  hsw);
            ctx.lineTo( hsw,  hw);
            ctx.lineTo(-hsw,  hw);
            ctx.lineTo(-hsw,  hsw);
            ctx.lineTo(-hw ,  hsw);

            ctx.closePath();
            ctx.fillStyle = '#e25d5d';
            ctx.globalCompositeOperation = 'multiply';
            ctx.fill();
            ctx.globalCompositeOperation = 'source-over';
            ctx.restore();

            // @NOTE(Grey): Draw the machine body
            var strokeWidth = 8;

            var w = 128;
            var h = 280;

            var x0 = -(w/2)+(strokeWidth/2);
            var x1 = x0+(w-strokeWidth);
            var y0 = -(h/2)+(strokeWidth/2);
            var y1 = y0+(h-strokeWidth);

            var r0 = 8;
            var r1 = 64;

            ctx.save();
            ctx.translate(width / 2.0, height / 2.0);
            ctx.scale(0.75, 0.75);
            ctx.rotate(-Math.PI * 0.5 + (Math.PI * 1.25));
            ctx.translate(-width / 2.0, -height / 2.0);
            ctx.translate(width * 0.20, -height * 0.28);

            // @NOTE(Grey): Draw the beams, It is wrapped in a function because
            // variables were leaking and screwing up other bits of the drawing
            (function() {
                for (var i = 0; i < beams.length; ++i) {
                    var beam = beams[i];
                    var x = beam.position.x;
                    var y = beam.position.y;
                    var w = beam.size.width;
                    var h = beam.size.height;

                    var hh = h/2;

                    if (i % 2 === 0) {
                        beam.widthTarget = Math.sin(i+(performance.now()*0.0005)*Math.PI)*20;
                    } else {
                        beam.widthTarget = Math.cos(i+(performance.now()*0.0005)*Math.PI)*20;
                    }

                    w += beam.widthTarget;

                    ctx.save();
                    ctx.fillStyle = beam.color;
                    ctx.beginPath();

                    ctx.moveTo(x, y);
                    ctx.lineTo(x+w-hh, y);
                    ctx.arcTo(x+w, y, x+w, y+hh, hh);
                    ctx.arcTo(x+w, y+h, x+w-hh, y+h, hh);
                    ctx.lineTo(x+w-hh, y+h);
                    ctx.lineTo(x, y+h);

                    ctx.closePath();
                    ctx.fill();
                    ctx.restore();
                }
            }())

            ctx.fillStyle = '#fff';
            ctx.strokeStyle = '#4ba8dc';
            ctx.lineWidth = strokeWidth;

            ctx.translate(width*0.45, height/2);
            ctx.rotate((1.0-(Math.random()*Math.PI*2.0)*2.0)*0.00125);

            ctx.shadowColor = 'rgba(0, 0, 0, 0.35)';
            ctx.shadowBlur = 20;
            ctx.shadowOffsetY = 5;

            ctx.beginPath();
            ctx.moveTo(x0+r0, y0);
            ctx.lineTo(x1-r1, y0);
            ctx.arcTo(x1, y0, x1, y0+r1, r1);
            ctx.lineTo(x1, y0+r1);
            ctx.lineTo(x1, y1-r1);
            ctx.arcTo(x1, y1, x1-r1, y1, r1);
            ctx.lineTo(x1-r1, y1);
            ctx.lineTo(x0+r0, y1);
            ctx.arcTo(x0, y1, x0, y1-r0, r0);
            ctx.lineTo(x0, y1-r0);
            ctx.lineTo(x0, y0+r0);
            ctx.arcTo(x0, y0, x0+r0, y0, r0);
            ctx.closePath();
            ctx.fill();
            ctx.shadowColor = 'transparent';
            ctx.stroke();

            ctx.lineWidth = strokeWidth/2;

            // @NOTE(Grey): Draw the hockey rink lines etc.
            var circleRadius = 32;

            // @NOTE(Grey): The middle circle
            ctx.beginPath();
            ctx.arc(0, 0, circleRadius, 0, Math.PI*2);
            ctx.closePath();
            ctx.stroke();

            // @NOTE(Grey): The middle dot
            ctx.fillStyle = '#4ba8dc';
            ctx.beginPath();
            ctx.arc(0, 0, circleRadius*0.35, 0, Math.PI*2);
            ctx.closePath();
            ctx.fill();

            // @NOTE(Grey): The lines
            ctx.beginPath();
            ctx.moveTo(-w/2,  h/4);
            ctx.lineTo( w/2,  h/4);
            ctx.moveTo(-w/2, -h/4);
            ctx.lineTo( w/2, -h/4);
            ctx.moveTo( 0  ,  h/4);
            ctx.lineTo( 0  ,  circleRadius);
            ctx.moveTo( 0  , -h/4)
            ctx.lineTo( 0  , -circleRadius);
            ctx.stroke();

            // @NOTE(Grey): The top and bottom dots
            ctx.beginPath();
            ctx.arc(0, -(h/2)*0.70, 2, 0, Math.PI*2);
            ctx.closePath();
            ctx.fill();

            ctx.beginPath();
            ctx.arc(0,  (h/2)*0.70, 2, 0, Math.PI*2);
            ctx.closePath();
            ctx.fill();

            // @NOTE(Grey): The spinning lights
            ctx.rotate(performance.now()*0.0005*Math.PI*2.0);
            ctx.fillStyle = lightGradient;

            ctx.beginPath();
            ctx.moveTo(-circleRadius/2, -4 );
            ctx.lineTo(-circleRadius  , -16);
            ctx.lineTo(-circleRadius  ,  16);
            ctx.lineTo(-circleRadius/2,  4 );
            ctx.moveTo( circleRadius/2, -4 );
            ctx.lineTo( circleRadius  , -16);
            ctx.lineTo( circleRadius  ,  16);
            ctx.lineTo( circleRadius/2,  4 );
            ctx.closePath();
            ctx.fill();

            ctx.fillStyle = '#4ba8dc';
            ctx.fillRect(-circleRadius/2, -4, circleRadius, 8);

            ctx.restore();

            requestAnimationFrame(update);
        }

        update();
    }

    function img_load(path) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.src = path;
            img.onload  = function() { resolve(img); }
            img.onerror = function() { reject (img); }
        });
    }

    $(window).ready(function() {
        var base_path = '/assets/build/images/index/animation/';
        var image_paths = [
            'circle_grey02@2x.png',
            'circle_grey03@2x.png',
            'circle_grey04@2x.png',
            'ring_grey02@2x.png',
            'ring_grey03@2x.png',
            'ring_grey04@2x.png',
            'rect_grey02@2x.png',
            'rect_grey03@2x.png'
        ];
        var image_promises = [];

        for (let i = 0; i < image_paths.length; ++i) {
            image_promises[i] = img_load(base_path + image_paths[i]);
        }

        Promise
            .all(image_promises)
            .then(function(images) {
                init(images);
            });
    });
}());
